import { type Types, utilityClasses } from '@fiverr-private/theme';

export const DEFAULT: Types.LayoutType = {
    paddingX: {
        default: '6',
        sm: '8',
    },
    paddingTop: {
        default: '6',
        sm: '8',
    },
    paddingBottom: {
        default: '12',
        sm: '16',
    },
    maxWidth: { default: '1400px' },
    className: utilityClasses.paddingX_0_xxl,
};

export const EQUAL_PADDING: Types.LayoutType = {
    padding: {
        default: '6',
        sm: '8',
    },
    className: utilityClasses.paddingX_0_xxl,
};
